import React, { useEffect, useState } from "react";

import { Error } from "@churchofjesuschrist/eden-alert";

import Spinner from "../../generic/loading/loading-spinner/loading-spinner";
import useManagedStrings from "../../utils/use-managed-strings";
import HelpArticleDisplay from "../help-article-display/help-article-display";

const stringGroups = [
  { name: "shared", keys: ["invalidArticleFormat", "unableLoadArticle"] },
];

const badLoader = {
  get: () => {
    var p = new Promise(() => {
      // eslint-disable-next-line no-throw-literal
      throw "Loader not provided";
    });
    return p;
  },
};

const HelpArticleLoader = ({
  article: articleName,
  loader = badLoader,
}) => {
  const {managedStrings:useStrings} = useManagedStrings(stringGroups);
  const [data, setData] = useState({
    status: { loading: false, error: false, message: null },
    article: null,
  });

  useEffect(() => {
    const load = async () => {
      try {
        const loadedArticle = await loader.get(articleName);
        if (!loadedArticle || !loadedArticle.contents) {
          throw useStrings.invalidArticleFormat;
        }
        setData({
          status: { loading: false, error: false, message: null },
          article: loadedArticle,
        });
      } catch (e) {
        const message = typeof e.message != "undefined" ? e.message : e;

        setData({
          status: { loading: false, error: true, message: message },
          article: null,
        });
      }
    };

    const isFirst =
      data.article === null && !data.status.error && !data.status.loading;
    const isLoading =
      data.article == null && !data.status.error && data.status.loading;

    if (isFirst) {
      setData({
        status: { loading: true, error: false, message: null },
        article: null,
      });
    } else if (isLoading) {
      load();
    }
  }, [data, articleName, loader, useStrings.invalidArticleFormat]);

  return (
    <div>
      {data.status.loading ? (
        <Spinner data-id="help-article-load-spinner" large={true} />
      ) : null}
      {/*NOTE: we should find and catch these in dev and testing
    so I am going to keep this simple and not translate strings in this component */}
      {data.status.error ? (
        <Error data-id="help-article-load-error">
          <div>
            <p>{useStrings.unableLoadArticle}:</p>
            {data.status.message ? <div>{data.status.message}</div> : null}
          </div>
        </Error>
      ) : null}
      {data.article ? (
        <HelpArticleDisplay
          data-id="help-article-load-contents"
          article={data.article}
          showTitle={true}
        />
      ) : null}
    </div>
  );
};

export default HelpArticleLoader;
